/**
 * @since 7.1.0
 */
export var AttendeeStatus;
(function (AttendeeStatus) {
    /**
     * @platform Android
     * @since 7.1.0
     */
    AttendeeStatus["NONE"] = "none";
    /**
     * @platform Android, iOS
     * @since 7.1.0
     */
    AttendeeStatus["ACCEPTED"] = "accepted";
    /**
     * @platform Android, iOS
     * @since 7.1.0
     */
    AttendeeStatus["DECLINED"] = "declined";
    /**
     * @platform Android
     * @since 7.1.0
     */
    AttendeeStatus["INVITED"] = "invited";
    /**
     * @platform iOS
     * @since 7.1.0
     */
    AttendeeStatus["UNKNOWN"] = "unknown";
    /**
     * @platform iOS
     * @since 7.1.0
     */
    AttendeeStatus["PENDING"] = "pending";
    /**
     * @platform Android, iOS
     * @since 7.1.0
     */
    AttendeeStatus["TENTATIVE"] = "tentative";
    /**
     * @platform iOS
     * @since 7.1.0
     */
    AttendeeStatus["DELEGATED"] = "delegated";
    /**
     * @platform iOS
     * @since 7.1.0
     */
    AttendeeStatus["COMPLETED"] = "completed";
    /**
     * @platform iOS
     * @since 7.1.0
     */
    AttendeeStatus["IN_PROCESS"] = "inProcess";
})(AttendeeStatus || (AttendeeStatus = {}));
//# sourceMappingURL=attendee-status.js.map